import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setMyPresence, listenToPresence } from "../../redux/Messages/PresenceAction";
// import { ding } from "util/Sound";
function PresenceGate({ userDetails, setMe, startPresence }) {

  useEffect(() => {
    if (userDetails?.email) {
      const cleanup = setMe({ email: userDetails.email, displayName: userDetails.name || userDetails.displayName });
      // listen globally to others' presence (optional; if you list people, also listen there)
      const stop = startPresence();

      // // Init FCM token for this user
      //   import("../../messaging").then(({ initFCMForUser }) => {
            
      //       initFCMForUser(userDetails.email, (payload) => {
      //           // foreground push fallback (optional)

      //           const title = payload?.notification?.title || "New message";
      //           const body = payload?.notification?.body || "";
      //           if ("Notification" in window && Notification.permission === "granted") {
      //               new Notification(title, { body });
      //               ding();

      //           }
      //       });
      //   });

        
      return () => { typeof cleanup === "function" && cleanup(); typeof stop === "function" && stop(); };
    }
  }, [userDetails, setMe, startPresence]);
  return null;
}
export default connect(
  s => ({ userDetails: s.loginAuth.userDetails }),
  d => ({ setMe: (a)=>d(setMyPresence(a)), startPresence: ()=>d(listenToPresence()) })
)(PresenceGate);
